import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Enterprise } from "@/components/site/Enterprise";
import { Capabilities } from "@/components/site/Capabilities";
import { SelectedWork } from "@/components/site/SelectedWork";
import { Govxi } from "@/components/site/Govxi";
import { GlobalPresence } from "@/components/site/GlobalPresence";
import { Engagements } from "@/components/site/Engagements";
import { Newsroom } from "@/components/site/Newsroom";
import { Footer } from "@/components/site/Footer";

const Home = () => (
  <div className="bg-[#0A0A0A] text-white antialiased">
    <Header />
    <main>
      <Hero />
      <Enterprise />
      <Capabilities />
      <SelectedWork />
      <Govxi />
      <GlobalPresence />
      <Engagements />
      <Newsroom />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
